/**
 * Numero com unidade (v2.1, p.26).
 *
 * Numero a direita, com algarismos tabulares, e a unidade em cinza, menor e
 * sem negrito: `4.832 h`, `R$ 320,50/h`, `28.560 km`. Nunca `4832h`.
 *
 * O alinhamento a direita e o `tabular-nums` vem do utilitario `numero`, junto,
 * porque o atalho `font:` do token zera `font-variant-numeric` — separados, os
 * digitos voltariam a dancar de linha em linha.
 *
 * A unidade e o texto apagado (#736A64), que na v2.1 passa 4,5:1 nos tres
 * fundos onde a Medida aparece: o card, o rebaixado do rodape da tabela e o
 * fundo da pagina.
 */
export function Medida({
  valor,
  unidade,
  colado = false,
}: {
  readonly valor: string;
  readonly unidade: string;
  /** `true` para sufixos que nao levam espaco, como o `/h` de `R$ 320,50/h`. */
  readonly colado?: boolean;
}) {
  return (
    <span className="numero text-tinta">
      {valor}
      <span className="txt-unidade">
        {colado ? '' : ' '}
        {unidade}
      </span>
    </span>
  );
}
